/* eslint-disable no-case-declarations */
import { createSelector } from 'reselect';
import { USERS_ERROR_CODES } from '../utils/consts';
import { actionTypes } from '../actions';
// eslint-disable-next-line import/no-cycle
import { generateJID } from '../utils';

export const moduleName = 'communicateModal';

const initialState = {
  callInfo: {},
  type: null,
  unread: {},
  isBusy: false,
  isOutcoming: false,
  isIncoming: false,
  isCalling: false,
  isSpeaking: false,
  chats: {},
  isConnected: false,
  userVideoStream: false,
  offset: undefined,
  isReconnect: false,
  isChatOpened: false,
  lastCallError: null,
  calleeBrief: undefined,
  callerBrief: undefined,
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.CLOSE_COMMUNICATE_MODAL:
      return {
        ...state,
        type: null,
        isBusy: false,
        isIncoming: false,
        callInfo: {},
        isCalling: false,
        isSpeaking: false,
        userVideoStream: false,
        isChatOpened: false,
      };
    case actionTypes.CLOSE_COMMUNICATE_MODAL_CHAT:
      return {
        ...state,
        isChatOpened: false,
      };
    case actionTypes.OPEN_COMMUNICATE_MODAL:
      return {
        ...state,
        type: action.modalType,
        person: action.person,
        isOutcoming: action.isOutcoming,
        isIncoming: action.isIncoming,
        isBusy: false,
        isCalling: false,
        isSpeaking: false,
        isPickUp: false,
        lastCallError: null,
      };
    case actionTypes.OPEN_COMMUNICATE_MODAL_CHAT:
      return {
        ...state,
        isChatOpened: true,
      };
    case actionTypes.PROCESSING_CALL:
      return {
        ...state,
        isCalling: true,
        isBusy: false,
      };
    case actionTypes.SPEAKING:
      return {
        ...state,
        isSpeaking: true,
        isCalling: false,
        isBusy: false,
      };
    case actionTypes.STOP_COMMUNICATION:
      return {
        ...state,
        isSpeaking: false,
        isCalling: false,
        isOutcoming: false,
        isIncoming: false,
        isBusy: false,
        isPickUp: false,
      };
    case actionTypes.CREATE_CALL:
      return {
        ...state,
        callInfo: {
          avTime: action.avTime,
          callId: action.callId,
          callerId: action.callerId,
          calleeId: action.consultant.id,
          info: '',
          error: false,
        },
        isBusy: false,
        isPickUp: false,
        lastCallError: null,
        calleeBrief: action.calleeBrief,
        callerBrief: {
          id: action.callerId,
        },
      };
    case actionTypes.CREATE_CALL_ERROR:
      return {
        ...state,
        callInfo: {
          info: action.info,
          error: true,
        },
        lastCallError: {
          info: action.info,
          internalError: action.internalError,
        },
      };
    case actionTypes.GET_CALL_INFO:
      return {
        ...state,
        callInfo: {
          callId: action.payload.id,
          callerId: action.payload.callerId,
          calleeId: action.payload.consultant.id,
          fcid: action.payload.fcid,
          fcidCost: action.payload.fcidCost,
          consulted: action.payload.consulted,
          info: '',
          error: false,
          lastCallError: null,
        },
        calleeBrief: {
          costPerMinute: action.payload.consultant.costPerMinute,
          service: action.payload.consultant.service,
          avatar: action.payload.consultant.avatar ? { id: action.payload.consultant.avatar.id } : undefined,
          imgUrl: action.payload.consultant.imgUrl,
          avatarUrl: action.payload.consultant.avatarUrl,
          nickname: action.payload.consultant.nickname,
          isPro: Boolean(action.payload.consultant.pro),
          id: action.payload.consultant.id,
        },
        callerBrief: {
          id: action.payload.callerId,
          avatar: action.payload.consulted.avatar ? { id: action.payload.consulted.avatar.id } : undefined,
          imgUrl: action.payload.consulted.imgUrl,
          avatarUrl: action.payload.consulted.avatarUrl,
        },
      };
    case actionTypes.CHOOSE_CHAT_PERSON:
      const { person } = action;
      const chats = { ...state.unread };
      delete chats[generateJID(person.id, true)];
      return {
        ...state,
        unread: chats,
        person: {},
        isChatOpened: false,
      };
    case actionTypes.CHANGE_UNREAD_MSG:
      return {
        ...state,
        unread: {
          ...state.unread,
          [action.from]: true,
        },
      };
    case actionTypes.CLEAR_CHATS:
      return {
        ...state,
        unread: {},
      };
    case actionTypes.CHANGE_CHAT:
      return {
        ...state,
        chats: action.payload,
      };
    case actionTypes.CHANGE_CONNECTION_STATUS:
      return {
        ...state,
        isConnected: action.payload,
      };
    case actionTypes.CHANGE_VIDEO_STATUS:
      return {
        ...state,
        userVideoStream: action.payload,
      };
    case actionTypes.CALEE_IS_BUSY:
      return {
        ...state,
        isBusy: true,
        callInfo: {},
        type: null,
        person: {},
        isOutcoming: false,
        isIncoming: false,
        isCalling: false,
        isSpeaking: false,
        isPickUp: false,
        lastCallError: null,
      };
    case actionTypes.PICK_UP_CALL:
      return {
        ...state,
        isPickUp: true,
        lastCallError: null,
      };
    case actionTypes.SET_TIME_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case actionTypes.LOGGED_OFF:
      return {
        ...initialState,
      };
    case actionTypes.CHANGE_RECONNECTION_STATUS:
      return {
        ...state,
        isReconnect: action.payload,
      };
    case actionTypes.CLEAR_CALL_BRIEFS:
      return {
        ...state,
        callerBrief: undefined,
        calleeBrief: undefined,
      };
    default:
      return state;
  }
};

const stateSelector = (state) => state[moduleName];

export const selectLastCallError = createSelector(
  stateSelector,
  (communicateModal) => communicateModal.lastCallError,
);

export const selectCalledProIsUnavailable = createSelector(
  selectLastCallError,
  (lastCallError) => !!(lastCallError
                && lastCallError.internalError
                && lastCallError.internalError === USERS_ERROR_CODES.PRO_IS_NOT_AVAILABLE),
);



// WEBPACK FOOTER //
// ./reducers/chat.js